import { NBreakevenConfig } from "./types"

export function getDefaultNBreakeven(): NBreakevenConfig {

    const GrainPrice = 185
    const NPrice = 1.5

    return {
        Enabled: false,
        GrainPrice,
        NPrice,
        NAdjustment: calculateNBreakevenAdjustment(GrainPrice, NPrice)
    }
}

export function calculateNBreakevenAdjustment(grainPrice: number, nPrice: number) {

    return grainPrice
        ? Math.round(10 * (5 - (nPrice / (grainPrice / 1000))))
        : undefined

}
